import { featureCategories } from '@/mocks/categories';

const sectionDescriptions = [
  {
    title: 'Pants & Shorts',
    desc: 'Premium trousers, denim, shorts, and joggers from verified sellers. Every style from streetwear cargos to tailored chinos — all QC-tested by community buyers.',
    bgColor: 'bg-[#f0ebe3]',
  },
  {
    title: 'Headwear',
    desc: 'Caps, beanies, bucket hats, and snapbacks from top-tier factories. Logo accuracy, stitching quality, and shape retention verified across every listing.',
    bgColor: 'bg-[#e8e4df]',
  },
  {
    title: 'Matching Sets',
    desc: 'Coordinated tracksuits, two-piece outfits, and athleisure sets. Full ensemble QC so colors and materials match perfectly between top and bottom.',
    bgColor: 'bg-[#e4ddd3]',
  },
];

export default function FeatureGrid() {
  return (
    <section className="relative py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-start gap-6 mb-10 md:mb-14">
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight lg:w-[40%]">
            Shop<br />Smart
          </h2>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed lg:w-[40%] lg:pt-3">
            Use our <strong className="text-foreground-900">CSSBuy spreadsheet</strong> to navigate every category with confidence. Each link is verified by experienced buyers in the community, so you always find the best sellers.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-7 gap-5 md:gap-6">
          {featureCategories.map((cat, idx) => {
            if (idx === 0) {
              return (
                <a
                  key={cat.seq}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="lg:col-span-3 group block rounded-2xl overflow-hidden bg-white hover:scale-[1.01] transition-transform duration-300 cursor-pointer"
                >
                  <div className={`h-[260px] md:h-[340px] ${sectionDescriptions[idx].bgColor} flex items-center justify-center p-6`}>
                    <img
                      src={cat.imageUrl}
                      alt={`CSSBuy ${cat.name} Spreadsheet`}
                      title={`CSSBuy ${cat.name} Spreadsheet`}
                      className="w-full h-full object-cover object-center rounded-xl"
                      loading="lazy"
                    />
                  </div>
                  <div className="px-5 py-5">
                    <h3 className="font-heading text-xl font-bold text-foreground-900 mb-2">
                      {sectionDescriptions[idx].title}
                    </h3>
                    <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                      {sectionDescriptions[idx].desc}
                    </p>
                    <span className="text-xs text-foreground-500 border-b border-foreground-300 pb-0.5">
                      Browse collection &rarr;
                    </span>
                  </div>
                </a>
              );
            }
            return (
              <a
                key={cat.seq}
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                className="lg:col-span-2 group block rounded-2xl overflow-hidden bg-white hover:scale-[1.01] transition-transform duration-300 cursor-pointer"
              >
                <div className="px-5 pt-5 pb-0">
                  <h3 className="font-heading text-lg font-bold text-foreground-900 text-center">
                    {sectionDescriptions[idx].title}
                  </h3>
                  <p className="text-xs text-foreground-500 text-center mt-1.5 leading-relaxed">
                    {sectionDescriptions[idx].desc}
                  </p>
                </div>
                <div className={`h-[200px] md:h-[260px] ${sectionDescriptions[idx].bgColor} flex items-center justify-center p-5 mt-4`}>
                  <img
                    src={cat.imageUrl}
                    alt={`CSSBuy ${cat.name} Spreadsheet`}
                    title={`CSSBuy ${cat.name} Spreadsheet`}
                    className="w-full h-full object-cover object-center rounded-xl"
                    loading="lazy"
                  />
                </div>
                <div className="px-5 py-3 text-center">
                  <span className="text-xs text-foreground-500 border-b border-foreground-300 pb-0.5">
                    Browse collection &rarr;
                  </span>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}